import O10g014111Stores from "./store/O10g014111Stores";

export default {
  o10g014111Stores: O10g014111Stores.instance,
};
